import { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import Icon from '../../Nodes/Icon'

class Popup extends Component {
    constructor(props) {
        super(props)
        this.element = document.createElement('div')
        this.element.classList.add('popup__wrapper')
    }

    state = { 
        open: true,
        x: 0,
        y: 0,
        dragInitialXPos: undefined,
        dragInitialYPos: undefined,
        dragXOffset: 0,
        dragYOffset: 0
    }

    getElementSize = (element) => {
        const { width, height } = element.getBoundingClientRect()
        const style = element.currentStyle || (window && window.getComputedStyle(element))
        const marginLeft = style['margin-left']
        const marginRight = style['margin-right']
        const marginTop = style['margin-top']
        const marginBottom = style['margin-bottom']
        // const borderLeft = style['border-left-width']
        // const borderRight = style['border-right-width']
        return { 
            width: width + parseInt(marginLeft) + parseInt(marginRight),
            height: height + parseInt(marginTop) + parseInt(marginBottom)
        }
    }

    getOffset = () => {
        const { x, y, dragInitialXPos, dragInitialYPos, dragXOffset, dragYOffset } = this.state
        const screenWidth = window && window.innerWidth
        const screenHeight = window && window.innerHeight
        const { width, height } = this.getElementSize(this.element)

        let offset = {}

        if (this.dragging()) {
            offset = {
                x: x + (dragXOffset - dragInitialXPos),
                y: y + (dragYOffset - dragInitialYPos)
            }
        }
        else 
            offset = { x, y }

        if (offset.x < 0)
            offset.x = 0
        if (offset.x >= screenWidth - width)
            offset.x = screenWidth - width
        if (offset.y < 0)
            offset.y = 0
        if (offset.y >= screenHeight - height)
            offset.y = screenHeight - height

        return offset
    }

    dragging = () => !isNaN(this.state.dragInitialXPos) && !isNaN(this.state.dragInitialYPos)

    // Drag callbacks
    onDragStart = (e) => {
        this.props.onDragStart && this.props.onDragStart(e)
        this.setState({ dragInitialXPos: e.screenX, dragInitialYPos: e.screenY, dragXOffset: e.screenX, dragYOffset: e.screenY })
    }
    onDragEnd = () => this.setState({ ...this.getOffset(), dragInitialXPos: undefined, dragInitialYPos: undefined })
    onDrag = (e) => {
        if (this.dragging())
            this.setState({ dragXOffset: e.screenX, dragYOffset: e.screenY })
    }    

    // Life cycle functions
    renderPopup = () => {
        const open = 
            typeof(this.props.open) !== 'undefined' ?
                this.props.open :
                this.state.open

        const { title, onClose, active, id, className, style } = this.props

        return (
            <div id={id}
                 className={'popup' + (active || this.dragging() ? ' popup--active' : '') + ` ${className}`}
                 style={style}
                 onMouseMove={this.onDrag}
                 onMouseLeave={this.onDragEnd}
                 onMouseUp={this.onDragEnd}>
                <div className="popup__header"
                     onMouseDown={this.onDragStart}>
                    <div dangerouslySetInnerHTML={{ __html: title }} />
                    <div>
                        <Icon onClick={() => this.setState({ open: !open })}>{open ? 'expand_more' : 'expand_less'}</Icon>
                        {onClose && <Icon onClick={onClose}>close</Icon>}
                    </div>
                </div>
                <div className={'popup__body' + (open ? '' : ' popup__body--hidden')}>
                    {this.props.children}
                </div>
            </div>
        )
    }

    render() {
        const { x, y } = this.getOffset()

        this.element.style.left = `${x}px`
        this.element.style.top = `${y}px`

        if (this.props.zindex)
            this.element.style.zIndex = this.props.zindex

        return ReactDOM.createPortal(
            this.renderPopup(),
            this.element
        )
    }

    componentDidMount() {
        document.body.appendChild(this.element)

        if (this.props.initialPosition)
            this.setState({ ...this.props.initialPosition })

        
    }

    componentWillUnmount() {
        document.body.removeChild(this.element)
    }
}

Popup.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    onDragStart: PropTypes.func,
    initialPosition: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }),
    active: PropTypes.bool,
    zindex: PropTypes.number
}

export default Popup